import React from 'react';
import { ILiveRegionProps } from './types';

export function LiveRegion(props: ILiveRegionProps) {
  return (
    <div
      className={props.liveRegionClassName}
      aria-live={props['aria-live']}
      aria-label={props.screenReaderText}
      role={props.role}
    >
      {props.showText && props.screenReaderText}
    </div>
  );
}

LiveRegion.defaultProps = {
  liveRegionClassName: 'live-region',
  'aria-live': 'polite',
  role: 'region',
  screenReaderText: '',
  showText: false,
};
